<template>
    <div class="AdminRequestStatus">
        <div v-for="(item, index) in statuses" v-bind:key="index">
            <div v-bind:class="isActive(item) ? `text-${item.variant} border-${item.variant}` : ''"
                 class="AdminRequestStatus-statusContainer">
                <i class="fi" v-bind:class="item.icon"></i>
            </div>
        </div>
        <div clasS="ml-3">
            <div v-bind:class="tickets ? `text-success border-success` : ''"
                 class="AdminRequestStatus-statusContainer">
                <i class="fi flaticon-upload"></i>
            </div>
        </div>
    </div>
</template>

<script>

    import Utils from '@/utils';

    export default {
        name: "AdminRequestStatus",
        data() {
            return {
                statuses: Utils.getRequestStatuses()
            }
        },
        props: {
            status: {
                type: String,
                default: ''
            },
            tickets: {
                type: Boolean,
                default: false
            }
        },
        methods: {

            isActive: function (status) {
                const currentStatus = Utils.getRequestStatusSettings(this.status);

                switch(currentStatus.name) {
                    case 'rejected':
                        return status.name === 'rejected';
                    case 'warning':
                        return status.name === 'warning';
                    default:
                        return currentStatus.step >= status.step;
                }

            }

        }
    }
</script>

<style scoped>

</style>